export interface Purchase {
  name: string
  city: string
  region: string
}

export const purchases: Purchase[] = [
  { name: 'Julien M.', city: 'Lyon', region: 'France' },
  { name: 'Christophe D.', city: 'Nantes', region: 'France' },
  { name: 'Sandrine L.', city: 'Bordeaux', region: 'France' },
  { name: 'Karim B.', city: 'Toulouse', region: 'France' },
  { name: 'Michel R.', city: 'Strasbourg', region: 'France' },
  { name: 'Laurent P.', city: 'Lille', region: 'France' },
  { name: 'Émilie F.', city: 'Rennes', region: 'France' },
  { name: 'Nicolas T.', city: 'Marseille', region: 'France' },
  { name: 'Sébastien G.', city: 'Nice', region: 'France' },
  { name: 'Céline V.', city: 'Montpellier', region: 'France' },
  { name: 'Thierry A.', city: 'Paris', region: 'France' },
  { name: 'Pascal H.', city: 'Grenoble', region: 'France' },
]
